import React from 'react';
import { getActiveIcon } from 'library/helpers';
import { DocLink, DocPages } from 'components/Help/';
import CompetencyTypeFormInput from './input';

const config = {
  // List Table
  list: {
    // Table Columns
    columns: [
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        sorter: true,
        defaultSortOrder: 'ascend',
        width: '280px'
      },
      {
        title: 'No. of Competencies',
        dataIndex: 'num_competencies',
        width: '200px',
        align: 'center',
        sorter: false
      },
      {
        title: 'Managed in SF',
        dataIndex: 'is_integration_managed',
        width: '200px',
        align: 'center',
        sorter: true,
        filterMultiple: false,
        filters: [
          {
            text: 'Managed in SF',
            value: true
          },
          {
            text: 'Not managed in SF',
            value: false
          }
        ],
        render: (text, record) => getActiveIcon(record.is_integration_managed)
      },
      {
        title: 'Active',
        dataIndex: 'active',
        width: '120px',
        align: 'center',
        sorter: true,
        filterMultiple: false,
        filters: [
          {
            text: 'Active',
            value: true
          },
          {
            text: 'Inactive',
            value: false
          }
        ],
        render: (text, record) => getActiveIcon(record.active)
      }
    ],
    // Deleting
    confirmMessage: item => (
      <div>
        <p>
          Are you sure you wish to delete the competency
          {' '}
          <b>{item.name}</b>
          ?
        </p>
        <p>
          This action cannot be undone.
        </p>
      </div>
    ),
    // Filtering
    sorter: {
      field: 'name',
      order: 'ascend'
    },
    filters: {},
    customFilters: {
      name: {
        filterDropdownVisible: false,
        filtered: false,
        contains: true,
        searchFields: ['name'],
        searchValue: ''
      }
    },
    // General
    title: <DocLink page={DocPages.competencyTypes}>Competency Types</DocLink>
  },
  // Detail Screen
  detail: {
    // General
    emptyMessage: 'Please select a Competency Type',
    title: 'Competency Type',
    tabItems: [
      {
        key: 0,
        title: 'Details',
        component: props => (
          <CompetencyTypeFormInput
            {...props}
            messages={{
              is_integration_managed: 'This data is managed by another system and cannot be edited'
            }}
            title="Competency Type"
          />
        )
      }
    ]
  }
};

export default config;
